'use client';
import React from 'react';
import HelpfulButton from './HelpfulButton';
import MenuReporting from './menuReporting';
import { CommentBottomDetailOptsWrapper } from '@/styles/product/comment';
import { callAfterLogin, JDILogin } from '@/lib/jdiClientUtils';
import { useRef } from 'react';
import {
  EXPOSURE_RECORD as REVIEW_LIST_EXPOSURE_RECORD,
  sendClickTrack as reviewListSendClickTrack,
} from '@/tracks/25338';
import { useTranslation } from '@/i18n/client';

import { sendClickTrack } from '@/tracks/25217';
import PingLunIcon from '@/assets/icons/lun.svg';
interface CustomComentItemProps {
  commentId: string; // 评论id
  usefulNum: number; // 有用数量
  commentNum: number; // 评论数量
  content?: string; // 评论内容
  imageList?: any; // 图片列表
  videoList?: any; // 视频列表
  currentIsUseful?: boolean; // 是否有用
  anonymousFlag?: boolean; // 是否匿名
  currentUserOperation?: boolean; // 当前用户操作
  skuId?: string;
}
interface Props {
  commentItem: CustomComentItemProps; // 评论数据
  reportReqParams?: any; // 举报参数
  reportFn?: () => void; // 举报成功后的回调
  onComment?: () => void; // 评论成功后的回调
  deleteNotify?: () => void; // 删除成功后的回调
  anonymousFn?: (v: any) => void; // 点击匿名回调
}

export default function CommentBottomDetailOpts({
  commentItem,
  reportReqParams,
  reportFn,
  onComment,
  anonymousFn,
  deleteNotify,
}: Props) {
  const { commentId, commentNum, currentIsUseful, usefulNum, skuId } = commentItem || {};
  const { t } = useTranslation();
  const currentRef = useRef<HTMLDivElement>(null);
  const onInnerComment = () => {
    reviewListSendClickTrack.Productdetail_Comment_Card_Btn({
      skuid: `${skuId || '-100'}`,
      commentId: `${commentId || '-100'}`,
      index: 1,
      button_name: '2',
    });
    // console.log("currentRef", currentRef.current?.closest(".MuiDialog-container"))
    sendClickTrack.Productdetail_ReviewsFloor_CommentBtn_Click();
    const parentContainer = currentRef.current?.closest('.MuiDialog-container');
    if (parentContainer) {
      parentContainer.removeAttribute('tabindex');
    }

    callAfterLogin(async () => {
      const userInfo = await JDILogin.getInstance().getUserInfo();
      if (userInfo.isLoggedIn) {
        onComment?.();
      }
    });
  };

  const [expConfig, setExpConfig] = React.useState<any>(null);
  React.useEffect(() => {
    const config = '{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}';
    setExpConfig({
      help: {
        expTag: 'exp|' + REVIEW_LIST_EXPOSURE_RECORD.Productdetail_Comment_Card_Btn_Expo,
        data: {
          skuid: `${skuId}` || '-100',
          button_name: '1',
          commentId: `${commentId}` || '-100',
        },
        config: config,
      },
      comment: {
        expTag: 'exp|' + REVIEW_LIST_EXPOSURE_RECORD.Productdetail_Comment_Card_Btn_Expo,
        data: {
          skuid: `${skuId}` || '-100',
          button_name: '2',
          commentId: `${commentId}` || '-100',
        },
        config: config,
      },
      more: {
        expTag: 'exp|' + REVIEW_LIST_EXPOSURE_RECORD.Productdetail_Comment_Card_Btn_Expo,
        data: {
          skuid: `${skuId}` || '-100',
          button_name: '3',
          commentId: `${commentId}` || '-100',
        },
        config: config,
      },
    });
  }, [commentId, skuId]);

  return (
    <CommentBottomDetailOptsWrapper ref={currentRef} className='detailBasicButton'>
      {expConfig && (
        <>
          <HelpfulButton
            data={{ currentIsHelp: currentIsUseful, commentId, helpfulNum: String(usefulNum) }}
            expConfig={expConfig}
          />
          {/* <div className='line'></div> */}
          <div
            className='btn'
            exptag={expConfig?.comment?.expTag}
            data-exptag-json-param={JSON.stringify(expConfig?.comment?.data)}
            data-exptag-config={expConfig?.comment?.config}
            onClick={onInnerComment}
          >
            {/* <i className="pinglunIcon mar"></i> */}
            <PingLunIcon className='pinglunIcon mar'></PingLunIcon>
            {`${t('dp.commentSection.comment')}${commentNum !== 0 ? '(' + commentNum + ')' : ''}`}
          </div>
          {/* <div className='line'></div> */}
          <MenuReporting
            commentItem={commentItem}
            reportReqParams={reportReqParams}
            reportFn={reportFn}
            deleteNotify={deleteNotify}
            anonymousFn={anonymousFn}
          />
        </>
      )}
    </CommentBottomDetailOptsWrapper>
  );
}
